module.exports = __webpack_public_path__ + "static/media/mysti-jack-footer.47457a25.png";